import React from "react";

import { MoreVert as MenuIcon } from "@mui/icons-material";
import makeStyles from "@mui/styles/makeStyles";
import { Menu, MenuItem, IconButton } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  videoContent: {
    display: "grid",
    height: "100%",
    gridGap: theme.spacing(1),
  },
  loadingVideoText: {
    position: "absolute",
    overflowWrap: "break-word",
  },
  player: {
    maxWidth: "100%",
    width: "100%",
    position: "absolute",
    height: "100%",
    border: "0",
    allowfullscreen: "true",
  },
  root: {
    margin: 0,
    position: "relative",
    // display: "flex",
  },
  caption: {
    top: 0,
    position: "absolute",
    left: 0,
    right: 0,
    textAlign: "center",
    background:
      "linear-gradient(to bottom, rgba(0,0,0,0.85) 10%, rgba(0,0,0,0) 100%)",
    paddingBottom: theme.spacing(2),
    color: "#fff",
    display: "flex",
    alignItems: "center",
  },
  cationLabel: {
    flexGrow: 1,
  },
  playIconOverlay: {
    display: "grid",
    placeItems: "center",
    top: "25%",
    bottom: "35%",
    left: "35%",
    right: "35%",
    position: "absolute",
    textAlign: "center",
    background: "rgba(0,0,0,0.85)",
    borderRadius: theme.spacing(2),
    cursor: "pointer",
    zIndex: 1,
    color: "#fff",
    "&:hover": {
      background: `radial-gradient(#2e2e2e, rgba(0,0,0,0.85))`,
    },
  },
  playIcon: {
    width: "90%",
    height: "90%",
  },
  iframeContent: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
}));

const LiveVideoPlayerIframe = ({
  label,
  sources,
  onSetCameraLocationClick,
  playAll,
}) => {
  const classes = useStyles();

  const [menuAnchorEl, setMenuAnchorEl] = React.useState(null);
  const menuOpen = Boolean(menuAnchorEl);
  const handleMenuButtonClick = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => setMenuAnchorEl(null);

  const iframeSrc = sources.find((x) => x.type === "iframe")?.source;

  console.log(iframeSrc);

  const handleCameraLocationClick = () => {
    setMenuAnchorEl(null);
    onSetCameraLocationClick();
  };

  return (
    <figure className={classes.root}>
      <div className={classes.videoContent}>
        <video poster="/live-video-poster.svg">
          Sorry, your browser doesn't support embedded videos.
        </video>
        <div className={classes.iframeContent}>
          <iframe
            className={classes.player}
            src={iframeSrc}
            allowFullScreen
          ></iframe>
        </div>
      </div>

      <figcaption className={classes.caption}>
        <div className={classes.cationLabel}>{label}</div>
        <div>
          <IconButton
            color="inherit"
            aria-controls={menuOpen ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={menuOpen ? "true" : undefined}
            onClick={handleMenuButtonClick}
            size="small"
          >
            <MenuIcon />
          </IconButton>
          <Menu
            anchorEl={menuAnchorEl}
            open={menuOpen}
            onClose={handleMenuClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <MenuItem onClick={handleCameraLocationClick}>
              Rename camera
            </MenuItem>
          </Menu>
        </div>
      </figcaption>
    </figure>
  );
};

export default LiveVideoPlayerIframe;
